export default {
	form: [
		{
			title: '您多大年龄（岁）？',
			type: 'input',
			value: '',
			options: [
				{
					placeholder: '请输入您的年龄',
					value: '',
					key: 'age',
					rightText: '岁',
					type: 'number'
				}
			]
		},
		{
			title: '您的性别？',
			type: 'radio',
			value: '',
			key: 'gender',
			options: [
				{ value: 1, label: '男' },
				{ value: 2, label: '女' }
			]
		},
		{
			title: '您的身高和体重？',
			type: 'input',
			value: '',
			options: [
				{
					placeholder: '请输入您的身高',
					value: '',
					key: 'height',
					rightText: '厘米'
				},
				{
					placeholder: '请输入您的体重',
					value: '',
					key: 'weight',
					rightText: '公斤'
				}
			]
		},

		{
			title: '目前（或曾经）吸烟吗？ ',
			type: 'radio',
			value: '',
			key: 'cigs',
			options: [
				{
					value: 1,
					label: '是',
					tips: {
						title: '吸烟',
						label: '吸烟是中风的一个重要危险因素，被动吸烟者中风风险是主动吸烟的2倍。请及时戒烟，不吸烟者应避免被动吸烟。如果即刻戒烟，吸烟导致的中风风险将迅速下降，5年后吸烟带来的中风风险几乎消失。'
					}
				},
				{ value: 0, label: '否' }
			]
		},
		{
			title: '您每天饮酒的酒精量会超过10g吗（约相当于1听330毫升啤酒）？',
			type: 'radio',
			value: '',
			key: 'drink',
			options: [
				{
					value: 1,
					label: '是',
					tips: {
						title: '饮酒过度',
						label: '大量饮酒者应减少饮酒或戒酒。轻中度饮酒可能具有一定保护作用，不饮酒者不提倡用少量饮酒方法预防心脑血管疾病。避免酗酒，男性不超过2个标准杯/天，女性不超过1个标准杯/天（1标准杯=12g酒精）。'
					}
				},
				{ value: 0, label: '否' }
			]
		},
		{
			title: '您每天食用水果和蔬菜的种类至少有6种吗？',
			type: 'radio',
			value: '',
			key: 'diet',
			options: [
				{ value: 0, label: '是' },
				{
					value: 1,
					label: '否',
					tips: {
						title: '饮食不均衡',
						label: '每日饮食种类应多样化，使能量和营养的摄入趋于合理；增加蔬菜、水果和低脂奶制品的摄入并减少饱和脂肪的摄入，同时建议多摄入富含坚果类食物的地中海饮食，可能有利于降低中风风险。'
					}
				}
			]
		},

		{
			title: '您每周至少进行2小时30分钟的体育锻炼吗？',
			type: 'radio',
			value: '',
			key: 'activity',
			options: [
				{ value: 0, label: '是' },
				{
					value: 1,
					label: '否',
					tips: {
						title: '缺少运动',
						label: '应选择适合自己的体育锻炼来降低中风风险。建议健康成年人从事有氧运动（例如跑步），每周3-4次，每次持续约40分钟，可涉及中度至强度的体力活动。'
					}
				}
			]
		},
		{
			title: '在过去的一年，您是否曾有过巨大的精神或情感压力？',
			type: 'radio',
			value: '',
			key: 'stress',
			options: [
				{
					value: 1,
					label: '是',
					tips: {
						title: '压力过大',
						label: '情绪应激与中风等心血管事件密切相关。如果您曾有过巨大的精神和情感压力，希望您保持健康的生活方式，必要时寻求心理健康教育或心理健康疏导。'
					}
				},
				{ value: 0, label: '否' }
			]
		},
		{
			title: '您的母亲/父亲在65岁之前是否有过中风或心脏病发作？',
			type: 'radio',
			value: '',
			key: 'familys',
			options: [
				{
					value: 1,
					label: '是',
					tips: {
						title: '家族病史',
						label: '您的直系亲属在65岁前曾有过中风/心脏病发作，您的中风风险会增加3倍。请密切关注血压、血糖、认知能力等指标，必要时向医生寻求专业指导。'
					}
				},
				{ value: 0, label: '否' }
			]
		},
		// TODO：带输入框的
		{
			title: '您的收缩压（血压度数中的高值）是多少？',
			type: 'radio',
			value: '',
			key: 'sbp',
			options: [
				{
					type: 'input',
					value: '',
					placeholder: '请输入血压数值',
					rightText: '（mmHg)',
					tips: {
						title: '血压过高',
						label: '您需要定期就医，按照医师建议强化生活方式干预或药物治疗来控制血压。每日监测血压至少2次，血压平稳后每周监测血压2次，鼓励家庭自测血压。',
						max: 140
					},
					rule: { max: 250, min: 90 }
				},
				{ value: 0, label: '不知道' }
			]
		},
		{
			title: '您正在服用降压药吗？',
			type: 'radio',
			value: '',
			key: 'hyprx',
			options: [
				{ value: 1, label: '是' },
				{ value: 0, label: '否' }
			]
		},
		{
			title: '您曾被医生诊断为糖尿病吗？',
			type: 'radio',
			value: '',
			key: 'dm',
			options: [
				{
					value: 1,
					label: '是的，一年前',
					tips: {
						title: '糖尿病',
						label: '糖尿病是中风的独立危险因素，可将中风的风险增加1倍以上。您应改进生活方式，控制饮食，加强体育锻炼。每周自我检测血糖2-4次，并根据医生建议药物治疗。'
					}
				},
				{
					value: 2,
					label: '是的，一年内',
					tips: {
						title: '糖尿病',
						label: '糖尿病是中风的独立危险因素，可将中风的风险增加1倍以上。您应改进生活方式，控制饮食，加强体育锻炼。每周自我检测血糖2-4次，并根据医生建议药物治疗。'
					}
				},
				{ value: 0, label: '没有' }
			]
		},
		{
			title: '您曾被医生诊断患有心血管/外周血管疾病吗？',
			label: [
				'心血管疾病如冠心病、心绞痛、心肌梗死、心律失常、心衰等',
				'外周血管疾病如颈动脉狭窄、颈部椎动脉狭窄，四肢动脉的狭窄等'
			],
			type: 'radio',
			value: '',
			key: 'cvd',
			options: [
				{
					value: 1,
					label: '是的，一年前',
					tips: {
						title: '心脑血管疾病',
						label: '患有其他类型心脏病（心绞痛，心衰，心脏瓣膜病包括人工瓣膜和先天心脏缺陷）和外周动脉疾病（包括颈动脉狭窄和/或颈部椎动脉狭窄，四肢动脉的狭窄）也有很高的中风风险。不同类型的心衰及心脏缺陷有很多药物和手术治疗的选择。请与您的医生探讨出最好的治疗策略，以降低您的中风风险。'
					}
				},
				{
					value: 2,
					label: '是的，一年内',
					tips: {
						title: '心脑血管疾病',
						label: '患有其他类型心脏病（心绞痛，心衰，心脏瓣膜病包括人工瓣膜和先天心脏缺陷）和外周动脉疾病（包括颈动脉狭窄和/或颈部椎动脉狭窄，四肢动脉的狭窄）也有很高的中风风险。不同类型的心衰及心脏缺陷有很多药物和手术治疗的选择。请与您的医生探讨出最好的治疗策略，以降低您的中风风险。'
					}
				},
				{ value: 0, label: '没有' }
			]
		},
		{
			title: '您曾被医生诊断为左心室肥厚吗？',
			type: 'radio',
			value: '',
			key: 'lvh',
			options: [
				{
					value: 1,
					label: '是的，一年前',
					tips: {
						title: '左心室肥厚',
						label: '左室肥厚患者的中风风险将加倍。您应积极找专科医师治疗，医生将会根据您的总体情况及可能存在的其他危险因素制定具体的脑中风预防方案。'
					}
				},
				{
					value: 2,
					label: '是的，一年内',
					tips: {
						title: '左心室肥厚',
						label: '左室肥厚患者的中风风险将加倍。您应积极找专科医师治疗，医生将会根据您的总体情况及可能存在的其他危险因素制定具体的脑中风预防方案。'
					}
				},
				{ value: 0, label: '没有' }
			]
		},
		{
			title: '您曾被医生诊断为房颤吗？',
			type: 'radio',
			value: '',
			key: 'af',
			options: [
				{
					value: 1,
					label: '是的，一年前',
					tips: {
						title: '房颤',
						label: '房颤可增加中风风险4-5倍。您应积极找专科医师治疗，医生将会根据您的总体情况及可能存在的其他危险因素制定具体的脑中风预防方案。'
					}
				},
				{
					value: 2,
					label: '是的，一年内',
					tips: {
						title: '房颤',
						label: '房颤可增加中风风险4-5倍。您应积极找专科医师治疗，医生将会根据您的总体情况及可能存在的其他危险因素制定具体的脑中风预防方案。'
					}
				},
				{ value: 0, label: '没有' }
			]
		},
		{
			title: '您曾被医生告知具有认知问题或患有老年痴呆症吗？',
			type: 'radio',
			value: '',
			key: 'cognitive',
			options: [
				{
					value: 1,
					label: '是的，一年前',
					tips: {
						title: '认知障碍',
						label: '认知障碍或痴呆有可能在以后导致中风。如果您被诊断为认知障碍或痴呆，应积极找专科医师治疗，医生将会根据您的总体情况及可能存在的其他危险因素制定具体的脑中风预防方案。'
					}
				},
				{
					value: 2,
					label: '是的，一年内',
					tips: {
						title: '认知障碍',
						label: '认知障碍或痴呆有可能在以后导致中风。如果您被诊断为认知障碍或痴呆，应积极找专科医师治疗，医生将会根据您的总体情况及可能存在的其他危险因素制定具体的脑中风预防方案。'
					}
				},
				{ value: 0, label: '没有' }
			]
		},
		{
			title: '您或您周围的人认为您记忆力差吗？',
			type: 'radio',
			value: '',
			key: 'poor_memory',
			options: [
				{ value: 1, label: '是' },
				{ value: 0, label: '否' }
			]
		},
		{
			title: '您曾被医生诊断为创伤性脑损伤吗？',
			label: ['创伤性脑损伤多为交通事故、跌倒、坠落等意外而直接或间接作用导致头部致伤'],
			type: 'radio',
			value: '',
			key: 'injury',
			options: [
				{
					value: 1,
					label: '是的，一年前',
					tips: {
						title: '创伤性脑损伤',
						label: '创伤性脑损伤通常涉及不同程度的脑损害，可能导致中风及其他神经系统疾病（例如认知能力下降或痴呆）请密切关注血压、认知能力等指标，必要时向医生寻求专业指导。'
					}
				},
				{
					value: 2,
					label: '是的，一年内',
					tips: {
						title: '创伤性脑损伤',
						label: '创伤性脑损伤通常涉及不同程度的脑损害，可能导致中风及其他神经系统疾病（例如认知能力下降或痴呆）请密切关注血压、认知能力等指标，必要时向医生寻求专业指导。'
					}
				},
				{ value: 0, label: '没有' }
			]
		}
		// {
		//     title:'您曾被医生诊断为中风或短暂性脑缺血发作（小中风）吗？',
		//     label:['小中风属于短暂性脑缺血，症状主要有短暂性身体某侧肢体麻木或者乏力，短暂性语言不利或找不到正确词语表达，短暂性单眼或双眼视物不清或视物重影，短暂性行走困难或平衡失调，短暂性头晕、头痛。上述症状往往几分钟后就会消失，持续时间最多也不超过24小时。'],
		//     type:'radio',
		//     value:'',
		//     key:'mini_stroke',
		//     options:[
		//         {value:1,label:'是的，一年前',tips:{title:'中风病史',label:'有中风或缺血性中风病史的患者，一年内再次发生中风几率较高。请做好预防并咨询您的医生以制定降低中风风险的最佳治疗策略。'}},
		//         {value:2,label:'是的，一年内',tips:{title:'中风病史',label:'有中风或缺血性中风病史的患者，一年内再次发生中风几率较高。请做好预防并咨询您的医生以制定降低中风风险的最佳治疗策略。'}},
		//         {value:0,label:'没有'}
		//     ]
		// },
	]
}
